// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"673fad49","977":"ab598817"}[chunkId] + ".chunk.js";
};